import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { useCookies } from 'react-cookie';
import { Controller, useForm } from 'react-hook-form';
import { doLogin } from '../../Network/Auth/Login';
import { Routes } from '../../constants';
import { showSnackbar } from '../../utils/snackbar';
import { getTenantPublicUrl } from '../../utils/tenant';

function Copyright({ siteName, siteUrl }) {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href={siteUrl}>
                {siteName}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    }
}));

export default function Login({ siteDetails }) {
    const classes = useStyles();
    const [, setCookie] = useCookies(['pgAdminToken']);
    const siteUrl = getTenantPublicUrl(siteDetails);
    const {
        handleSubmit,
        formState: { errors },
        control
    } = useForm();

    const onSubmit = async (data: any) => {
        try {
            const oneYearFromNow = new Date();
            oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
            setCookie('pgAdminToken', await doLogin(data), {
                path: Routes.home,
                expires: oneYearFromNow
            });
        } catch (e) {
            showSnackbar(
                e?.response?.data?.error
                    ? e?.response?.data?.error
                    : 'Login failed. Please try again.'
            );
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>
                <form
                    className={classes.form}
                    onSubmit={handleSubmit(onSubmit)}
                    noValidate
                >
                    <Controller
                        name="email"
                        as={
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                autoFocus
                            />
                        }
                        control={control}
                        error={!!errors?.email}
                    />
                    <Controller
                        name="password"
                        as={
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                            />
                        }
                        control={control}
                        error={!!errors?.password}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Sign In
                    </Button>
                </form>
            </div>
            <Box mt={8}>
                <Copyright siteName={siteDetails?.name} siteUrl={siteUrl} />
            </Box>
        </Container>
    );
}
